import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

class ModalExample extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: true,
      backdrop: false
    }
  }

  render() {
    const externalCloseBtn = (
      <button
        type="button"
        className="close"
        style={{
          display: 'none',
          position: 'absolute',
          top: '15px',
          right: '15px'
        }}
        onClick={this.toggle}
      >
        &times;
      </button>
    )
    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          external={externalCloseBtn}
          backdrop="static"
        >
          <ModalHeader>Подтверждение регистрации</ModalHeader>
          <ModalBody style={{ textAlign: 'left' }}>
            Чтобы получить доступ к полному функционалу, наберите на домофоне
            своего подъезда код: <b>{this.props.code}</b> <br /> <br />
            И затем приложите к нему свой ключ.
          </ModalBody>
          <ModalFooter>
            <Link to="/">
              <Button color="warning" block>
                Вернуться в демо режим
              </Button>
            </Link>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ModalExample



// WEBPACK FOOTER //
// ./src/components/modals/RegisterModal.js